<typography *ngIf="!value" look="inputPlaceholder"> {{ placeholder }} </typography>

<typography *ngIf="value"> {{ value }} </typography>
